var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectpdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FF0000",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4688 15.0312C22.5641 15.0312 21.8281 14.2953 21.8281 13.3906V8H13.4375C12.0159 8 10.8594 9.15655 10.8594 10.5781V29.4219C10.8594 30.8435 12.0159 32 13.4375 32H26.5625C27.9841 32 29.1406 30.8435 29.1406 29.4219V15.0312H23.4688ZM14.7031 24.875H18.1119C18.5002 24.875 18.815 25.1898 18.815 25.5781C18.815 25.9664 18.5002 26.2812 18.1119 26.2812H14.7031C14.3148 26.2812 14 25.9664 14 25.5781C14 25.1898 14.3148 24.875 14.7031 24.875ZM14 21.8281C14 21.4398 14.3148 21.125 14.7031 21.125H25.0156C25.4039 21.125 25.7188 21.4398 25.7188 21.8281C25.7188 22.2164 25.4039 22.5312 25.0156 22.5312H14.7031C14.3148 22.5312 14 22.2164 14 21.8281ZM25.0156 17.375C25.4039 17.375 25.7188 17.6898 25.7188 18.0781C25.7188 18.4664 25.4039 18.7812 25.0156 18.7812H14.7031C14.3148 18.7812 14 18.4664 14 18.0781C14 17.6898 14.3148 17.375 14.7031 17.375H25.0156Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2344 13.392C23.2344 13.5212 23.3395 13.6264 23.4688 13.6264H28.8272C28.6986 13.3889 28.5331 13.1708 28.3343 12.9827L23.8145 8.70664C23.6391 8.5407 23.4437 8.40228 23.2344 8.29297V13.392H23.2344Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectpdf);
export default __webpack_public_path__ + "static/media/projectpdf.74f0fa3ef003c9f79225ca3abfcef340.svg";
export { ForwardRef as ReactComponent };